import React from "react"
import { usePaths } from "@engaging-tech/routing"
import PromotionCard from "../../../ui/components/PromotionCard"

const Research = () => {
  const paths = usePaths()

  return (
    <PromotionCard
      title="Publish research"
      content={[
        "Upload your own research documents onto the WorkL business library to help educate others or promote your work on the Global Hub."
      ]}
      action={{
        description: "Publish research",
        linkTo: paths.resourceCentre.publish.research
      }}
    />
  )
}

export default Research
